
<template>
  <div class="container">
    <TabIndex v-if="active == 'home'" />
    <Orders v-if="active == 'order'" />
    <TabUser v-if="active == 'user'" />

    <div class="bottom-bar">
      <van-tabbar v-model="active" @change="onChange">
        <van-tabbar-item icon="home-o" name="home">
          <span>首页</span>
          <template #icon>
            <img
              :src="
                active == 'home'
                  ? require('@/images/bottom_tab_home_page_select.png')
                  : require('@/images/bottom_tab_home_page_highlighted.png')
              "
            />
          </template>
        </van-tabbar-item>
        <van-tabbar-item name="order">
          <span>{{ orderTabs.keyName }}</span>
          <template #icon>
            <img
              :src="
                active == 'order' ? orderTabs.iconUrl[0] : orderTabs.iconUrl[1]
              "
            />
          </template>
        </van-tabbar-item>
        <van-tabbar-item icon="friends-o" name="user">
          <span>用户</span>
          <template #icon>
            <img
              :src="
                active == 'user'
                  ? require('@/images/bottom_tab_bar_personal_select.png')
                  : require('@/images/bottom_tab_bar_personal_center.png')
              "
            />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import TabIndex from "../components/tabs/Index.vue";
// import QrScan from "../components/tabs/QrScan.vue";
import Orders from "./user/OrdersList.vue";
import TabUser from "../components/tabs/User.vue";
import tokenHelper from "@/helpers/token_helper";
const active = ref("home");
import { useStore } from "vuex";
import request from "@/api/request";
let stateContext;
let orderTabs = ref({});
let orderInterval = null;
export default {
  components: {
    TabIndex,
    // QrScan,
    Orders,
    TabUser,
  },
  setup() {
    defultOrderTabs();
    stateContext = useStore();
    // on the basis of  previous page source to  show  tab
    const routerTab = stateContext.state.homeRouter;
    if (routerTab !== "") {
      //clear  state  homeRouer  record
      active.value = stateContext.state.homeRouter;
      // stateContext.commit("clearHomeRouter");
    }
    //save  tab  record
    const onChange = (index) => {
      stateContext.commit("setHomeRouter", index);
    };
    orderInterval = setInterval(function () {
      if (tokenHelper.readAccessToken() != null) {
        checkPendingOrder();
      } else {
        clearInterval(orderInterval);
        defultOrderTabs();
      }
    }, 2000);

    if (active.value == "order" && tokenHelper.readAccessToken() == null) {
      active.value = "home";
    }
    return {
      active,
      orderTabs,
      onChange,
      ref,
    };
  },
  unmounted() {
    clearInterval(orderInterval);
  },
};
function defultOrderTabs() {
  orderTabs.value = {
    keyName: "订单",
    iconUrl: [
      require("@/images/bottom_tab_orders_select.png"),
      require("@/images/bottom_tab_orders_highlighted.png"),
    ],
  };
}
function checkPendingOrder() {
  let param = {};
  param["status"] = "in_progress";
  request.getOrderList(param).then((res) => {
    if (res.data.results.length != 0) {
      orderTabs.value = {
        keyName: "充电中",
        iconUrl: [
          require("@/images/index_orders_tab.png"),
          require("@/images/index_orders_tab.gif"),
        ],
      };
    } else {
      clearInterval(orderInterval);
      defultOrderTabs();
    }
  }).catch((error) => {
    console.error('获取订单列表失败:', error);
    // 网络错误时除定时器，避免持续请求
    clearInterval(orderInterval);
    defultOrderTabs();
  });
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
}
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
::v-deep .van-tabbar {
  padding-bottom: 10px;
}
</style>